<script>
export default {
  name: 'EventSelectionFlucs',
  props: {
    selectionFlucs: {
      type: Array,
      required: true,
    },
    isMobile: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    onlyHasOpenValue() {
      const { selectionFlucs } = this;
      return selectionFlucs.length === 1;
    },
    openFlucValue() {
      const { selectionFlucs } = this;
      const openFluc = selectionFlucs.reduce((a, b) => {
        return a.updatedAt < b.updatedAt ? a : b;
      });
      return openFluc.value;
    },
    highestFlucValue() {
      const { selectionFlucs, onlyHasOpenValue, $options: options } = this;
      const highestFluc = selectionFlucs.reduce((a, b) => {
        return a.value > b.value ? a : b;
      });
      return !onlyHasOpenValue ? options.filters.twoDecimalPlaces(highestFluc.value) : '-';
    },
    lowestFlucValue() {
      const { selectionFlucs, onlyHasOpenValue, $options: options } = this;
      const lowestFluc = selectionFlucs.reduce(function(a, b) {
        return b.value < a.value ? b : a;
      });
      return !onlyHasOpenValue ? options.filters.twoDecimalPlaces(lowestFluc.value) : '-';
    },
  },
};
</script>

<template>
  <div
    :class="{ 'selection-fluc-container-mobile': isMobile, 'selection-fluc-open-only': onlyHasOpenValue }"
    class="selection-fluc-container"
  >
    <div class="selection-fluc-container">
      <div class="selection-fluc-container__item">
        <div class="selection-fluc-container__header">OPEN</div>
        <div class="selection-fluc-container__value">{{ openFlucValue | twoDecimalPlaces }}</div>
      </div>
      <div class="selection-fluc-container__item fluc-up">
        <div class="selection-fluc-container__header">HIGH</div>
        <div class="selection-fluc-container__value">{{ highestFlucValue }}</div>
      </div>
      <div class="selection-fluc-container__item fluc-down">
        <div class="selection-fluc-container__header">LOW</div>
        <div class="selection-fluc-container__value">{{ lowestFlucValue }}</div>
      </div>
    </div>
  </div>
</template>
